export const riskStyles = {
  "VERY HIGH": { bg: "#FFE4E6", text: "#9F1239", border: "#FDA4AF", bar: "#BE123C" },
  EXTREME: { bg: "#FFE4E6", text: "#9F1239", border: "#FDA4AF", bar: "#E11D48" },
  HIGH: { bg: "#FFEDD5", text: "#C2410C", border: "#FDBA74", bar: "#F97316" },
  "USE CAUTION": { bg: "#FEF3C7", text: "#92400E", border: "#FCD34D", bar: "#F59E0B" },
  MODERATE: { bg: "#FEF3C7", text: "#92400E", border: "#FCD34D", bar: "#F59E0B" },
  LOW: { bg: "#DCFCE7", text: "#166534", border: "#86EFAC", bar: "#22C55E" },
};

export const confidenceStyles = {
  HIGH: "bg-[#EBF7EE] text-[#15803D] border-[#BBE7C6]",
  "MODERATE TO HIGH": "bg-[#EBF7EE] text-[#15803D] border-[#BBE7C6]",
  MEDIUM: "bg-[#FEF7EC] text-[#92400E] border-[#F5DFB8]",
  LOW: "bg-[#F4EFEA] text-[#7B887D] border-[#E5DFD7]",
};

const signalPalette = {
  rose: "bg-[#FFE4E6] text-[#9F1239] border-[#FDA4AF]",
  orange: "bg-[#FFEDD5] text-[#C2410C] border-[#FDBA74]",
  amber: "bg-[#FEF3C7] text-[#92400E] border-[#FCD34D]",
  green: "bg-[#DCFCE7] text-[#166534] border-[#86EFAC]",
  gray: "bg-[#F4EFEA] text-[#525E54] border-[#E5DFD7]",
};

export const getSignalStyle = (status = "") => {
  const s = status.toLowerCase();
  if (s.includes("not observed")) return signalPalette.gray;
  if (s === "detected" || s === "reproduced") return signalPalette.rose;
  if (s === "high" || s === "elevated") return signalPalette.orange;
  if (s === "observed") return signalPalette.orange;
  if (s.includes("moderate")) return signalPalette.amber;
  if (s === "unverified") return signalPalette.amber;
  if (s.includes("low")) return signalPalette.green;
  if (s.startsWith("standard")) return signalPalette.green;
  return signalPalette.gray;
};

export const statusStyles = {
  REPRODUCED: signalPalette.rose,
  OBSERVED: signalPalette.orange,
  UNVERIFIED: signalPalette.amber,
  UNCLEAR: signalPalette.gray,
};
